import { buildEndpoint } from './base.endpoints';

const BASE_PATH = '/Currencies';

export const currencyEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  basePath: () => BASE_PATH,
} as const;

export default currencyEndpoints;
